import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Preloading from "../../../components/basics/Preloading";
import back from "../../../assets/images/icons/arrow-right2.svg";
import methods from "../../../services/utility";
import apiMethod from "../../../services/api-service";
import DeleteModal from "../../../components/deleteModal/DeleteModal";
import Paginations from "../../../components/paginaton/Paginations";
import EditIcon from "../../../assets/images/icons/editIcon.svg";
import DeleteIcon from "../../../assets/images/icons/deleteIcon.svg";

const ProductWarehouse = () => {
  const { id, restaurantId } = useParams();
  const [loading, setLoading] = useState(false);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [gridDataFind, setGridDataFind] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [filterModel, setFilterModel] = useState({
    restaurantId: restaurantId,
    WarehouseId: id,
    categoryId: "",
    ProductTitle: "",
    productType: "",
    natureType: "",
    title: "",
    ProductCategoryId: "",
    code: "",
    size: 10,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [listProducts, setListProducts] = useState({
    restaurantId: restaurantId,
    WarehouseId: id,
    title: "",
    size: 10,
    part: 1,
    total: 0,
    parts: 0,
  });

  const [formModel, setFormModel] = useState({
    id: 0,
    productId: "",
    warehouseId: id,
    code: "",
    minInventory: "",
    maxInventory: "",
  });
  const [bulkyProducts, setBulkyProducts] = useState([]);
  const [productInputs, setProductInputs] = useState({});

  const findProduct = async () => {
    setLoading(true);
    const resp = await apiMethod.findProductForWarehouse(
      listProducts.restaurantId,
      listProducts.WarehouseId,
      listProducts.title
    );
    setLoading(false);
    if (methods.showApiErrors(resp)) {
      listProducts.total = resp.total;
      listProducts.parts = methods.calcPageParts(resp.total, resp.size);
      setListProducts({ ...listProducts });
      setGridDataFind(resp.data);
      const initialInputs = {};
      resp.data.forEach((item) => {
        initialInputs[item.id] = {
          minInventory: "",
          maxInventory: "",
        };
      });
      setProductInputs(initialInputs);
    }
  };

  const getGridData = async (customPart = null) => {
    const part = customPart ? customPart : filterModel.part;
    setLoading(true);
    const resp = await apiMethod.getWarehouseProducts(
      filterModel.WarehouseId,
      filterModel.ProductTitle,
      filterModel.code,
      filterModel.size,
      part
    );
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      filterModel.part = part;
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await findProduct();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, []);

  const resetFilters = () => {
    filterModel.WarehouseId = id;
    filterModel.ProductTitle = "";
    filterModel.ProductCategoryId = "";
    filterModel.code = "";
    filterModel.size = 10;
    filterModel.part = 1;
    filterModel.total = 0;
    filterModel.parts = 0;
    setFilterModel({ ...filterModel });
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.productId = "";
    formModel.warehouseId = id;
    formModel.code = "";
    formModel.minInventory = "";
    formModel.maxInventory = "";
    setFormModel({ ...formModel });
  };

  const resetListProdcut = () => {
    listProducts.restaurantId = restaurantId;
    listProducts.WarehouseId = id;
    listProducts.title = "";
    listProducts.size = 10;
    listProducts.part = 1;
    listProducts.total = 0;
    listProducts.parts = 0;
    setListProducts({ ...listProducts });
  };

  const closeAddProductModal = () => {
    setShowAddProductModal(false);
    const resetInputs = {};
    gridDataFind.forEach((item) => {
      resetInputs[item.id] = {
        minInventory: "",
        maxInventory: "",
      };
    });
    setProductInputs(resetInputs);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    resetForm();
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const validForm = (productId) => {
    let errors = [];
    const inputs = productInputs[productId];

    if (!inputs?.minInventory) {
      errors.push("موجودی بحرانی انبار باید مقدار داشته باشد");
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };
  const validFormBulky = (bulkyProducts, productInputs, gridDataFind) => {
    let errors = [];

    bulkyProducts.forEach((product) => {
      const inputs = productInputs[product.productId];

      if (!inputs?.minInventory || inputs.minInventory.trim() === "") {
        const productTitle =
          gridDataFind.find((i) => i.id === product.productId)?.title ||
          "نامشخص";
        errors.push(
          `برای محصول "${productTitle}" مقدار "موجودی بحرانی انبار" الزامی است`
        );
      }
    });

    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }

    return true;
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };
  const searchProducts = async () => {
    setLoading(true);
    await findProduct();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const clearProducts = async () => {
    setLoading(true);
    resetListProdcut();
    await findProduct();
    setLoading(false);
  };

  const handleInputChange = (id, field, value) => {
    setProductInputs((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));

    setBulkyProducts((prev) =>
      prev.map((p) => (p.productId === id ? { ...p, [field]: value } : p))
    );
  };

  const createItem = async (item) => {
    if (!validForm(item.id)) return false;
    const inputs = productInputs[item.id];
    const formData = {
      id: 0,
      productId: item.id,
      warehouseId: id,
      code: item.code,
      minInventory: inputs.minInventory,
      maxInventory: inputs.maxInventory || 0,
    };
    setLoading(true);
    const resp = await apiMethod.createWarehouseProduct(formData);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    setShowAddProductModal(false);
    await getGridData();
    setLoading(false);
    clearProducts();
    handleInputChange(item.id, "minInventory", "");
    handleInputChange(item.id, "maxInventory", "");
  };

  const editItem = async (id) => {
    setLoading(true);
    const respEdit = await apiMethod.getWarehouseProductInfo(id);
    const item = respEdit.data;
    formModel.id = item.id;
    formModel.productId = item.productId;
    formModel.warehouseId = item.warehouseId;
    formModel.code = item.code;
    formModel.minInventory = item.minInventory;
    formModel.maxInventory = item.maxInventory || 0;
    setFormModel({ ...formModel });
    setLoading(false);
    setShowEditModal(true);
  };
  const selectَItemToDelete = (item) => {
    setFormModel(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    const resp = await apiMethod.removeWarehouseProduct(formModel.id);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    await getGridData();
    await findProduct();
    resetForm();
    setLoading(false);
    setShowDeleteModal(false);
  };

  const editedProduct = async () => {
    setLoading(true);
    const resp = await apiMethod.createWarehouseProduct(formModel);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    await getGridData();
    setLoading(false);
    setShowEditModal(false);
  };

  const handleChangeCheckbox = (item, isChecked) => {
    setBulkyProducts((prev) => {
      if (isChecked) {
        if (!prev.some((p) => p.productId === item.id)) {
          return [
            ...prev,
            {
              id: 0,
              productId: item.id,
              warehouseId: id,
              code: item.code,
              minInventory: 0,
              maxInventory: 0,
            },
          ];
        }
        return prev;
      } else {
        return prev.filter((p) => p.productId !== item.id);
      }
    });
  };

  const callPager = async (i) => {
    setLoading(true);
    setFilterModel({ ...filterModel, part: i });
    await getGridData(i);
    setLoading(false);
  };

  const addBulkyProduct = async () => {
    const isValid = validFormBulky(bulkyProducts, productInputs, gridDataFind);
    if (!isValid) return false;
    setLoading(true);
    const resp = await apiMethod.createBulkyWarehouseProduct(bulkyProducts);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    await getGridData();
    await findProduct();
    setBulkyProducts([]);
    setLoading(false);
    setShowAddProductModal(false);
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block mb-3">
              <Link
                to={`/warehouse/${restaurantId}/createWarehouse`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/warehouse/${restaurantId}/createWarehouse`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                کالای انبار
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                کالای انبار
                <a
                  href={`/wareHouse/${restaurantId}`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain mb-3">
              <div className="row g-3">
                <div className="col-12 col-md-3">
                  <label htmlFor="ProductTitle" className="mb-2">
                    عنوان
                  </label>
                  <input
                    type="text"
                    className="form-control input-form"
                    id="ProductTitle"
                    value={filterModel.ProductTitle}
                    onChange={(e) =>
                      setFilterModel({
                        ...filterModel,
                        ProductTitle: e.target.value,
                        part: 1,
                      })
                    }
                    placeholder="جستجو کنید..."
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label htmlFor="code" className="mb-2">
                    کد
                  </label>
                  <input
                    type="text"
                    className="form-control input-form"
                    id="code"
                    value={filterModel.code}
                    onChange={(e) =>
                      setFilterModel({
                        ...filterModel,
                        code: e.target.value,
                        part: 1,
                      })
                    }
                    placeholder="جتسجو کنید..."
                  />
                </div>
                <div className="col-2 d-flex align-items-end">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn-wrap search-btn"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      className="btn-wrap reset-btn"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
                <div className="col-4 d-flex justify-content-end align-items-end">
                  <button
                    className="btn btn-outline-purple custome-btn"
                    type="button"
                    onClick={() => setShowAddProductModal(true)}
                  >
                    <span className="align-middle d-inline-block">
                      افزودن کالا به انبار
                    </span>{" "}
                    <i className="bi bi-plus-circle align-middle"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="salemain">
              <span className="d-block text-start fw-bold fs-5">
                کالای انبار
              </span>
              <div className="table-responsive warhousetable">
                <table className="table table-md table-custom">
                  <thead className="">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">کد</th>
                      <th scope="col vertical-center">موجودی بحرانی انبار</th>
                      <th scope="col vertical-center">حداکثر ظرفیت انبار</th>
                      <th scope="col vertical-center">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <td scope="row">
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </td>
                        <td>{item.productTitle}</td>
                        <td>{item.code}</td>
                        <td>{methods.addNumSeperator(item.minInventory)}</td>
                        <td>{methods.addNumSeperator(item.maxInventory)}</td>
                        <td className="d-flex align-items-center justify-content-center gap-2">
                          <button
                            onClick={() => editItem(item.id)}
                            className="button-action"
                            type="button"
                          >
                            <img src={EditIcon} alt="Edit" />
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className="button-action"
                            type="button"
                          >
                            <img src={DeleteIcon} alt="delete" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={filterModel.total}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const addProductModal = () => {
    return (
      <>
        <div
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
          onClick={closeAddProductModal}
        >
          <div
            className="modal-dialog modal-xl modal-dialog-centered"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content px-3">
              <div className="modal-header">
                <h5 className="modal-title">افزودن کالا به انبار</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeAddProductModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-2">
                  <div className="col-3">
                    <label htmlFor="tit" className="form-label">
                      عنوان
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="tit"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={methods.addNumSeperator(listProducts.title)}
                      onChange={(e) => {
                        setListProducts({
                          ...listProducts,
                          title: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div
                    className="col-2 d-flex align-items-end"
                    style={{ marginBottom: "4px" }}
                  >
                    <button
                      type="button"
                      className="btn btn-purple me-1"
                      onClick={searchProducts}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-info"
                      onClick={clearProducts}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
                <div className="border rounded mt-4">
                  <p className="bg-light rounded-top p-3">
                    انتخاب کالاهای مورد نظر
                  </p>
                  <div className="table-responsive saletable m-3">
                    <table className="table table-striped table-md align-middle">
                      <thead className="">
                        <tr>
                          <th scope="col vertical-center" width="20px">
                            ردیف
                          </th>
                          <th scope="col vertical-center">عنوان</th>
                          <th scope="col vertical-center">
                            موجودی بحرانی انبار
                          </th>
                          <th scope="col vertical-center">
                            حداکثر ظرفیت انبار
                          </th>
                          <th scope="col vertical-center" width="50px">
                            عملیات
                          </th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {gridDataFind.map((item, index) => (
                          <tr key={item.id}>
                            <td scope="row">
                              {(listProducts.part - 1) * listProducts.size +
                                index +
                                1}
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-4">
                                <div>
                                  <input
                                    id={item.title}
                                    type="checkbox"
                                    className="ms-2"
                                    checked={bulkyProducts.some(
                                      (p) => p.productId === item.id
                                    )}
                                    onChange={(e) =>
                                      handleChangeCheckbox(
                                        item,
                                        e.target.checked
                                      )
                                    }
                                  />
                                </div>
                                <div>
                                  <label htmlFor={item.title}>
                                    {item.title}
                                  </label>
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                className="form-control inventory-inp"
                                type="text"
                                aria-label="Add your item here..."
                                style={{ direction: "rtl", textAlign: "right" }}
                                placeholder="موجودی بحرانی انبار"
                                value={
                                  productInputs[item.id]?.minInventory || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    item.id,
                                    "minInventory",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="form-control inventory-inp"
                                type="text"
                                aria-label="Add your item here..."
                                style={{ direction: "rtl", textAlign: "right" }}
                                placeholder="حداکثر ظرفیت انبار"
                                value={
                                  productInputs[item.id]?.maxInventory || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    item.id,
                                    "maxInventory",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <button
                                onClick={() => createItem(item)}
                                className="btn btn-purple"
                              >
                                افزودن
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                  <button
                    type="button"
                    className="btn custome-btn btn-link-purple"
                    onClick={closeAddProductModal}
                  >
                    انصراف
                  </button>
                  <button
                    type="button"
                    className="btn custome-btn btn-purple"
                    onClick={addBulkyProduct}
                  >
                    ثبت و ذخیره
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const editProductWarehouse = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: "block" }}
        onClick={closeEditModal}
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ویرایش کالا</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={closeEditModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-12">
                  <label htmlFor="min" className="form-label">
                    موجودی بحرانی انبار
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="min"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.minInventory}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        minInventory: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-12">
                  <label htmlFor="min" className="form-label">
                    حداکثر ظرفیت انبار
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="min"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.maxInventory}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        maxInventory: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                <button
                  type="button"
                  className="btn custome-btn btn-link-purple"
                  onClick={closeEditModal}
                >
                  انصراف
                </button>
                <button
                  onClick={editedProduct}
                  type="button"
                  className="btn custome-btn btn-purple"
                >
                  ثبت و ذخیره
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {renderItems()}
      {showAddProductModal && addProductModal()}
      {showEditModal && editProductWarehouse()}
      <DeleteModal
        showModal={showDeleteModal}
        closeModal={closeDeleteModal}
        deleteItem={deleteItem}
        text={"کالای انبار"}
      />
    </div>
  );
};

export default ProductWarehouse;
